import { Button, CircularProgress, SxProps, Theme, useTheme } from '@mui/material';
import React from 'react';

/**
 * CardButton
 * 卡片中的卡片按钮
 */
export default (props: {
  /**
   * 标题
   */
  title?: string;
  /**
   * 点击事件
   */
  onClick?: () => void;
  /**
   * 配色方案，默认primary
   */
  color?: 'error' | 'primary' | 'secondary' | 'success' | 'info' | 'warning';
  /**
   * 左侧按钮
   */
  icon?: string;
  /**
   * 内容对其方式
   */
  align?: 'left' | 'center' | 'right';
  /**
   * 样式
   */
  sx?: SxProps<Theme> | undefined;
  /**
   * 当前是否按钮事件正在处理
   */
  doing?: boolean;

  variant?: 'contained' | 'outlined' | 'text';
}) => {
  const { color, icon, align, sx, doing, variant } = props;
  const theme = useTheme();
  // 渲染
  return (
    <Button
      color={color || 'primary'}
      onClick={doing ? undefined : props.onClick}
      startIcon={
        doing ? (
          <CircularProgress
            sx={{
              marginLeft: '-20px',
              color: theme.palette[color || 'primary'].contrastText,
            }}
            size={14}
          />
        ) : icon ? (
          <img src={icon} />
        ) : undefined
      }
      sx={{
        display: 'flex',
        fontWeight: 'normal',
        fontSize: '14px',
        padding: '12px 16px',
        justifyContent: align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center',
        ...(sx || {}),
      }}
      fullWidth={true}
      variant={variant || 'contained'}
      disableElevation
    >
      {props.title}
    </Button>
  );
};
